module.exports = __webpack_public_path__ + "img/step3.79c1f310.png";